module.exports = __webpack_public_path__ + "assets/img/tit7.96af9a34.png";